import { NgModule, Optional, SkipSelf } from '@angular/core';
import { o7BuilderService } from '@07/builder';

import { SharedModule } from '../shared/shared.module';

import { FylkerRoutingModule } from './routing';
import { FylkerOverviewPage } from './overview';
import { FylkePage } from './fylke';

import { Fylke, Fylkeroversikt } from './types';

@NgModule({
  imports: [
    SharedModule,
    FylkerRoutingModule
  ],
  declarations: [
    FylkerOverviewPage,
    FylkePage
  ]
})
export class FylkerModule {
    constructor(@Optional() @SkipSelf() self: FylkerModule, private builder: o7BuilderService) {
        if (self) {
            throw new Error('ProfModule is already loaded.');
        } else {
            builder.mapComponent('node', {
                recipe_cat: {
                    type: Fylke
                }
                // ,
                // taxonomy: {
                //     type: Fylkeroversikt
                // }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+fylker/module.ts